<template>
  <el-select
    :style="`width:${width}`"
    ref="innerSelect"
    v-model="selection"
    popper-class="search-buy-task"
    filterable
    remote
    default-first-option
    :trigger-on-focus="false"
    :placeholder="placeholder"
    :disabled="disabled"
    :remote-method="searchBuyTask"
    :loading="searching"
    @change="handleChange"
  >
    <slot name="dropdown" />
    <template v-slot:empty>
      <slot name="dropdown" />
    </template>
    <el-option v-for="item in buyTaskOptions" :key="item.id" :label="item.label" :value="item.label">
      <div class="option-item">
        <p class="title">{{ item.label }}</p>
        <div class="content" :style="`width: calc(${width} - 50px)`">
          <p>{{ item.companyName }}</p>
          <p>{{ contentTypeMap[item.contentType] }} - {{ signBusinessTeamMap[item.signBusinessTeam] }}</p>
        </div>
      </div>
    </el-option>
  </el-select>
</template>

<script>
import axios from 'axios'
import cpTaskService from '@/api/cpTask'
import { contentTypeMap, signBusinessTeamMap } from '@/views/cpTask/const'

function listToMap(list, key = 'id') {
  return list.reduce((res, cur) => {
    res[cur[key]] = cur
    return res
  }, {})
}

const CancelToken = axios.CancelToken

export default {
  name: 'SearchBuyTask',
  props: {
    searchKey: {
      type: String,
      default: 'keyWord',
    },
    value: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    defaultOptions: {
      type: Array,
      default() {
        return []
      }
    },
    placeholder: {
      type: String,
      default: '请输入关键词搜索'
    },
    width: {
      type: String,
      default: '300px'
    }
  },
  data() {
    return {
      contentTypeMap,
      signBusinessTeamMap,

      buyTaskOptions: [],
      buyTaskMap: {},
      selection: '',
      searching: false
    }
  },
  watch: {
    defaultOptions(newVal) {
      this.buyTaskOptions = newVal
    },
    value(newVal) {
      this.selection = newVal
    }
  },
  mounted() {
    this.selection = this.value
    this.buyTaskOptions = this.defaultOptions
    this.buyTaskMap = listToMap(this.buyTaskOptions)
  },
  methods: {
    focus() {
      this.$refs.innerSelect.focus()
    },
    handleChange(selection) {
      const id = selection?.split(' -@- ')?.[0]
      let item = null
      if (id) {
        item = this.buyTaskMap[id]
      }
      this.$emit('update:value', selection)
      this.$emit('change', selection)
      this.$emit('select', item)
    },

    searchBuyTask(query) {
      if (query !== '') {
        const source = CancelToken.source()
        if (this.requestToken) {
          this.requestToken.cancel('search buy task cancel old request')
        }
        this.requestToken = source

        this.searching = true
        cpTaskService.search({
          page: 0,
          num: 100,
          [this.searchKey]: query
        }, { cancelToken: source.token }).then(resp => {
          this.buyTaskOptions = resp.list.map(item => {
            const value = `${item.id} -@- ${item.taskName}`
            return {
              value,
              label: value,
              ...item,
            }
          })
          this.buyTaskMap = listToMap(this.buyTaskOptions)
        }).catch(error => {
          // console.error(error)
          if (axios.isCancel(error)) {
            return console.log('取消请求')
          }
          this.$message({
            type: 'error',
            message: '搜索采买任务异常: ' + error.message,
            duartion: 5000
          })
        }).finally(_ => {
          this.searching = false
        })
      }
    }
  }
}
</script>

<style lang="scss">
.search-buy-task {
  .el-select-dropdown__item {
    height: auto;
    padding: 4px 16px;
    line-height: 1.5;
  }
  .option-item {

    .title {
      font-size: 14px;
      font-weight: 500;
    }

    .content {
      margin-top: 5px;
      font-size: 12px;

      p {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
